import React from "react"

import "bootstrap/dist/css/bootstrap.min.css"
import "yet-another-react-lightbox/styles.css"

import "./src/components/style/layout.css"
import "./src/components/style/spacing.css"
import RootWrapper from "./src/components/utils/RootWrapper"

export const wrapRootElement = ({ element }) => {
  return <RootWrapper>{element}</RootWrapper>
}
